import script from "./memberCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./memberCourse.vue?vue&type=script&setup=true&lang=js"

import "./memberCourse.vue?vue&type=style&index=0&id=60e0bd8c&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60e0bd8c"]])

export default __exports__